import type { OrderScan } from "@/lib/order-scan";

/**
 * Повтор штуки ЧЗ в сессии сборки/перемещений — отказ ДО запроса.
 *
 * Источник правды — бэк (`scanning/marks.py`, 409); экран лишь не гоняет
 * заведомо отказной скан в 1С и отвечает сразу. Сравнение — по нормальной
 * форме `01<GTIN>21<серийник>` без криптохвоста: одну штуку камера читает с
 * GS, ТСД — без него или в скобках. Её же бэк отдаёт полем `mark` позиции.
 */
export const DUPLICATE_MARK_TEXT =
  "Эта штука ЧЗ уже отсканирована в этой сессии — одна штука не считается дважды.";

/** Код штуки ЧЗ в нормальной форме; не код штуки — пусто. */
export function markOf(scan: OrderScan): string {
  return scan.kind === "datamatrix" && scan.gtin && scan.serial ? `01${scan.gtin}21${scan.serial}` : "";
}

/** Та же штука уже среди позиций сессии? */
export function sameMarkIn(scan: OrderScan, items: ReadonlyArray<{ mark?: string | null }>): boolean {
  const mark = markOf(scan);
  return !!mark && items.some((i) => i.mark === mark);
}
